import toSafeInteger from 'lodash/toSafeInteger';
import { GetServerSidePropsContext } from 'next';
import type { NextPage } from 'next';
import { cachedFetchPlannedPurchase } from '../../api/fetchPlannedPurchase';
import { AnnouncesIndexQuery } from '../../api/fetchPurchases';
import { useBreadcrumbs } from '../../components/_shared/Breadcrumbs/BreadcrumbsContext';
import { PlannedPurchasePosition } from '../../components/Purchases/PlannedPurchases/PlannedPurchasePosition/PlannedPurchasePosition';
import { Services } from '../../types';
import { PlannedPosition } from '../../types/entities';
import { firstParamValue } from '../../utils/nextRequest';

const PlannedPurchasePositionPage: NextPage<{
    position: PlannedPosition;
    total: number;
}> = ({ position, total }) => {
    useBreadcrumbs([
        { title: 'закупки', href: '/purchases' },
        { title: `позиция закупки ${position?.ordNumber}` },
    ]);

    return <PlannedPurchasePosition position={position} total={total} />;
};

export default PlannedPurchasePositionPage;

export const getServerSideProps = async (
    context: GetServerSidePropsContext<AnnouncesIndexQuery> & {
        req: { services: Services };
    }
) => {
    const queryPositionId = firstParamValue(context.query.slug);
    const [, queryPlanId, queryPositionNumber] =
        queryPositionId?.match(/^(\d+):(\d+)$/) || [];
    const planId = toSafeInteger(queryPlanId);
    const positionNumber = toSafeInteger(queryPositionNumber);
    const page = toSafeInteger(firstParamValue(context.query.page));
    const limit = toSafeInteger(firstParamValue(context.query.limit));

    if (!planId || !positionNumber) {
        return {
            redirect: {
                permanent: false,
                destination: '/planned-purchases',
            },
        };
    }

    try {
        const props = await cachedFetchPlannedPurchase(
            planId,
            positionNumber,
            page,
            limit
        );

        return {
            props: {
                ...props,
            },
        };
    } catch (error: any) {
        return {
            redirect: {
                permanent: false,
                destination: '/planned-purchases',
            },
        };
    }
};
